
// This file now exports references to your deployed Firebase Cloud Functions.
// It uses the Firebase Functions SDK to create callable function objects.

import { functions } from './services/firebase';
// FIX: Changed firebase/functions import to @firebase/functions.
import { httpsCallable } from '@firebase/functions';

// Each of these is now a reference to a deployed cloud function.
// Calling them will make a network request to your Firebase backend.
export const sendEmail = httpsCallable(functions, 'sendEmail');
export const notifyOfNewApplication = httpsCallable(functions, 'notifyOfNewApplication');
export const notifyOfApplicationStatusChange = httpsCallable(functions, 'notifyOfApplicationStatusChange');
export const notifyOfNewMessage = httpsCallable(functions, 'notifyOfNewMessage');
export const notifyOfNewMaintenanceRequest = httpsCallable(functions, 'notifyOfNewMaintenanceRequest');
export const notifyOfMaintenanceStatusChange = httpsCallable(functions, 'notifyOfMaintenanceStatusChange');
export const notifyTenantToActivateLease = httpsCallable(functions, 'notifyTenantToActivateLease');
export const notifyOfNewViewingRequest = httpsCallable(functions, 'notifyOfNewViewingRequest');
export const notifyOfViewingStatusChange = httpsCallable(functions, 'notifyOfViewingStatusChange');
export const notifyOfViewingReschedule = httpsCallable(functions, 'notifyOfViewingReschedule');
export const paystackWebhook = httpsCallable(functions, 'paystackWebhook');
export const initiateLeaseRenewal = httpsCallable(functions, 'initiateLeaseRenewal');
export const getIceServers = httpsCallable(functions, 'getIceServers');
export const fetchCreditReport = httpsCallable(functions, 'fetchCreditReport');
export const generateSmileIdToken = httpsCallable(functions, 'generateSmileIdToken');
export const extractAddressFromDocument = httpsCallable(functions, 'extractAddressFromDocument');
export const extractLeaseDetails = httpsCallable(functions, 'extractLeaseDetails'); // Added
export const initiateLeaseSigning = httpsCallable(functions, 'initiateLeaseSigning');
export const previewLeaseAgreement = httpsCallable(functions, 'previewLeaseAgreement'); // Added this
export const simulateEsignatureWebhook = httpsCallable(functions, 'eSignatureWebhook'); 
export const sendSmsOtp = httpsCallable(functions, 'sendSmsOtp');
export const verifySmsOtp = httpsCallable(functions, 'verifySmsOtp');
export const generateApplicationInsight = httpsCallable(functions, 'generateApplicationInsight');
